const isRegionsPlugin = (plugin)=>{
    return "addRegions" in plugin || "getRegions" in plugin || "regions" in plugin && "regionsContainer" in plugin;
};

export { isRegionsPlugin };
